import React from "react";
import { connect } from "react-redux";
import { ButtonToolbar, DropdownButton } from "react-bootstrap";
import MenuItem from "components/Nav";

const Sites = ({ list, current }) => (
  <ButtonToolbar>
    <DropdownButton
      title={(current && current.name) || ""}
      id={`dropdown-${"name"}`}
    >
      {list.map(item => (
        <MenuItem key={item.id} href={`/publishers/${item.id}`}>
          {item.name}
        </MenuItem>
      ))}
    </DropdownButton>
  </ButtonToolbar>
);

export default connect(
  (
    { sites: { main: { list } } },
    { match: { params: { publisherID: site_id } } }
  ) => ({
    list,
    current: list.find(item => item.id === +site_id)
  })
)(Sites);
